<template>
  <div class="share-container">
    <div class="share-item wechat" @click="handleShareWX">
      <em></em>
      <span>{{ $t('index.wechat') }}</span>
    </div>
    <div class="share-item linkedin" @click="handleShareLinked">
      <em></em>
      <span>{{ $t('index.linkedin') }}</span>
    </div>
    <div class="share-item weibo" @click="handleShareWB">
      <em></em>
      <span>{{ $t('index.weibo') }}</span>
    </div>

    <el-dialog :close-on-click-modal="false" align-center modal-class="wx" class="wx" append-to-body v-model="visible" :title="$t('index.share-wx')" width="320px" :before-close="handleClose">
      <div class="wx-share-content">
        <div class="qr"><img :src="'http://www.dataleading.cn/barcode/img.ashx?type=2d&text=' + encodeURIComponent($config.app.host + '/app/#/?v=' + $event.ID)" /></div>
        <p>
          {{ $t('index.share-wx-tips') }}
        </p>
      </div>
    </el-dialog>
  </div>
</template>

<script setup>
  import { ref, defineEmits, inject, onMounted, onUnmounted } from 'vue'
  const $event = inject('$event')
  const $config = inject('$config')
  const visible = ref(false)
  //
  const handleShareWX = () => {
    visible.value = true
  }
  const handleShareLinked = () => {
    var url = $config.app.host + '/app/#/?v=' + $event.ID
    var title = $event.EventName
    window.open(`https://www.linkedin.com/shareArticle?mini=true&url=${url}&title=${title}`)
  }
  const handleShareWB = () => {
    var url = $config.app.host + '/app/#/?v=' + $event.ID
    var title = $event.EventName
    window.open(`https://service.weibo.com/share/share.php?url=${encodeURIComponent(url)}&type=text&pic=&title=${title}`)
  }
</script>
<style lang="scss">
  .el-overlay {
    &.wx {
      background-color: transparent;
      .el-dialog {
        background-color: #fff;
      }
      .wx-share-content {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
      }
    }
  }
</style>
<style lang="scss" scoped>
  .share-container {
    display: flex;
    justify-content: space-around;
    align-items: center;
  }

  .share-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: var(--el-color-primary);

    em {
      background-repeat: no-repeat;
      width: 32px;
      height: 32px;
      display: block;
      background-size: 100% 100%;
    }
    &.wechat {
      em {
        background-image: url(~@/assets/img/wechat-1.png);
      }
    }
    &.linkedin {
      em {
        background-image: url(~@/assets/img/linkedin-1.png);
      }
    }
    &.weibo {
      em {
        background-image: url(~@/assets/img/weibo-1.png);
      }
    }
    span {
      margin: 0;
      text-align: center;
      font-size: 14px;
      line-height: 24px;
      display: block;
      color: var(--el-color-primary);
    }
  }
</style>
